import { ChainInfo } from "./use-chain-input";

export enum CrosswordFieldType {
    LABEL = 'label',
    INPUT = 'input'
}

export type CrosswordField = {
    type: CrosswordFieldType,
    position: {
        x: number,
        y: number
    },
    chain?: ChainInfo[],
    extraClass?: string,
    text?: string,
    correct?: string,
    pencil?: string,
    marked?: boolean
}

const data: [string, number][] = [
    ['dzwoneczek', 0],
    ['katarzyna', 1],
    ['szymborska', 4],
    ['dolittle', 2],
    ['malaria', 3],
    ['poradnik', 1],
    ['pippi', 5],
    ['norwegia', 2],
    ['sowa', 4],
    ['łazienki', 4],
    ['smrodek', 5],
    ['nika', 3],
    ['wykałaczka', 0],
    ['tran', 3],
    ['piegi', 5],
    ['ziarnko', 4],
];


const crossword: CrosswordField[] = data.reduce((prev: CrosswordField[], next, index) => {

    const [pass, x] = next;
    const letters = [];

    for (let i = 0; i < pass.length; i++) {

        const field: CrosswordField = {
            type: CrosswordFieldType.INPUT,
            position: { x: x + i, y: index },
            correct: pass[i],
            marked: x + i === 6,
            chain: [{ id: pass, index: i }],
        }

        if (i === 0) {
            field.pencil = `${index + 1}`
        }

        letters.push(field);
    }

    return [
        ...prev,
        ...letters
    ]
}, [] as CrosswordField[])

export default crossword;
